import { render, staticRenderFns } from "./NotificationsApp.vue?vue&type=template&id=5c34775c&scoped=true"
import script from "./NotificationsApp.vue?vue&type=script&lang=ts"
export * from "./NotificationsApp.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsApp.vue?vue&type=style&index=0&id=5c34775c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c34775c",
  null
  
)

export default component.exports